module.exports = __webpack_public_path__ + "static/img/bcg_1.5c7b7867.png";